import { Phone, Mail, MapPin } from "lucide-react";
const Footer = () => {
  const links = [{
    text: "Services",
    url: "/#services"
  }, {
    text: "Zone d'intervention",
    url: "/zone-intervention"
  }, {
    text: "Contact",
    url: "/contact"
  }, {
    text: "Mentions légales",
    url: "/mentions-legales"
  }];
  return <footer className="bg-gradient-to-br from-primary via-primary to-secondary text-white py-16 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent-alt/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Contact Info */}
          <div>
            <h3 className="text-2xl font-bold mb-6">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-4 group">
                <div className="w-12 h-12 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:bg-accent transition-all">
                  <Phone className="h-5 w-5 text-accent group-hover:text-white" />
                </div>
                <a href="tel:0646702617" className="hover:text-accent-alt transition-smooth font-medium">
                  06.46.70.26.17
                </a>
              </div>
              <div className="flex items-center space-x-4 group">
                <div className="w-12 h-12 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:bg-accent transition-all">
                  <Mail className="h-5 w-5 text-accent group-hover:text-white" />
                </div>
                <a href="mailto:jacky.couverture44@gmail.com" className="hover:text-accent-alt transition-smooth font-medium">
                  jacky.couverture44@gmail.com
                </a>
              </div>
              <div className="flex items-start space-x-4 group">
                <div className="w-12 h-12 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:bg-accent transition-all">
                  <MapPin className="h-5 w-5 text-accent group-hover:text-white" />
                </div>
                <span className="font-medium">
                  4 rue des Saules<br />
                  44119 Treillières
                </span>
              </div>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-2xl font-bold mb-6">Liens</h3>
            <nav className="space-y-3">
              {links.map(link => <a key={link.text} href={link.url} className="block hover:text-accent-alt transition-smooth font-medium hover:translate-x-2 transition-transform">
                  → {link.text}
                </a>)}
            </nav>
          </div>

          {/* Zone d'intervention */}
          <div>
            <h3 className="text-2xl font-bold mb-6">Zone d'intervention</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-accent rounded-full"></div>
                <span className="font-medium">Loire-Atlantique (44)</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-accent rounded-full"></div>
                <span className="font-medium">Vendée (85)</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-accent rounded-full"></div>
                <span className="font-medium">Maine-et-Loire (49)</span>
              </div>
            </div>
            <div className="mt-6 p-4 bg-white/10 backdrop-blur-sm rounded-xl">
              <div className="text-accent-alt font-bold mb-2">⚡ Intervention rapide</div>
              <div className="text-sm text-white/90">Devis gratuit sous 24h</div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 text-center space-y-2">
          <p className="text-white/90 font-medium">© 2025 Jacky Couverture - Tous droits réservés</p>
          <p className="text-white/70 text-sm">
            Créé par{" "}
            <a target="_blank" rel="noopener noreferrer" className="hover:text-accent-alt transition-smooth font-medium underline" href="https://www.createur-site-vitrine.fr/">
              Aerodrone Multiservice
            </a>
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;